module.exports = ".property-row {\n  background-color: white;\n  cursor: default;\n  padding: 20px;\n  padding-left: 50px; }\n\n.property-row:hover {\n  background-color: #E4E4E4;\n  cursor: default; }\n\n.property-name {\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 20px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/search/submarket-search/submarket-search.component.scss
// module id = ./src/app/shared/components/search/submarket-search/submarket-search.component.scss
// module chunks = main